(function () {
    'use strict';

    angular
        .module('tfc.retailer.UIGrid')
        .directive('tfcUiGrid', tfcUIGrid);

    function tfcUIGrid() {
        return {
            restrict: 'E',
            templateUrl: 'Util/UIGrid/UIGridInfiniteScroll.tmpl.html',
            controller: 'UIGridCtrl as vm',
            bindToController: true,
            scope: {
                options: '=',
                getDataFn: '&',
                getFormattedData: '&',
                getLastIdentifier: '&'
            }
        };
    }

}());